module.exports = __webpack_public_path__ + "img/germany-logo-icon.f5a91816.png";